/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Credential_PasswordInputs */

const vi_einvoice_credential_password = /** @type {(inputs: Einvoice_Credential_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mật khẩu MISA`)
};

/**

* @param {Einvoice_Credential_PasswordInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_credential_password = /** @type {((inputs?: Einvoice_Credential_PasswordInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Credential_PasswordInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_credential_password(inputs)
});